import styled from 'styled-components';

export default styled.div`
  background-color: ${({ styles }) => styles.color};
  height: ${({ styles }) => styles.height};
  max-height: ${({ styles }) => styles.height};
`;
